import { render, staticRenderFns } from "./leadTypeList.vue?vue&type=template&id=6f8aee65&scoped=true&"
import script from "./leadTypeList.vue?vue&type=script&lang=js&"
export * from "./leadTypeList.vue?vue&type=script&lang=js&"
import style0 from "./leadTypeList.vue?vue&type=style&index=0&id=6f8aee65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8aee65",
  null
  
)

export default component.exports